import type { SettlementDetail } from '@services/settlements/types'
import type { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SettlementMeterUsageCard } from '../SettlementMeterUsageCard'
import { MoneyField, StepIntro } from './fields'
import type { SettlementFormValues } from './useSettlementInputsForm'

function WaterGroup({
  title,
  prefix,
  form
}: {
  title: string
  prefix: 'hot_water' | 'cold_water'
  form: UseFormReturn<SettlementFormValues>
}) {
  const { t } = useTranslation('settlement')

  return (
    <div className="rounded-2xl border border-ink/[0.08] p-4">
      <h3 className="m-0 mb-3 font-display text-base font-bold text-ink">
        {title}
      </h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <MoneyField
          name={`${prefix}_price_per_m3` as keyof SettlementFormValues}
          label={t('fields.price_per_m3')}
          hint={t('hints.price_per_m3')}
          suffix="€/m³"
          required
          register={form.register}
        />
        <MoneyField
          name={`${prefix}_shared_annual` as keyof SettlementFormValues}
          label={t('fields.shared_annual')}
          hint={t('hints.shared_annual')}
          suffix="€"
          register={form.register}
        />
      </div>
    </div>
  )
}

export function StepWater({
  settlement,
  form,
  readOnly
}: {
  settlement: SettlementDetail
  form: UseFormReturn<SettlementFormValues>
  readOnly: boolean
}) {
  const { t } = useTranslation('settlement')

  return (
    <div className="space-y-4">
      <StepIntro>{t('wizard.water.intro')}</StepIntro>

      <SettlementMeterUsageCard
        settlement={settlement}
        readOnly={readOnly}
        blocks={['HOT_WATER', 'COLD_WATER']}
        embedded
      />

      <WaterGroup
        title={t('sections.hot_water')}
        prefix="hot_water"
        form={form}
      />
      <WaterGroup
        title={t('sections.cold_water')}
        prefix="cold_water"
        form={form}
      />
    </div>
  )
}
